import BaseModule from '../../../javascripts/helpers/baseModule';
import inViewport from '../../../javascripts/helpers/inViewport';

export default class FloatingLayer extends BaseModule {
  constructor(element) {
    super(element, element.getAttribute('data-js-module'));
    this.getElements([
      {
        id: 'toggle',
        selector: 'toggle'
      },
      {
        id: 'layer',
        selector: 'layer'
      }
    ]);

    this.bindEvents();
  }

  static isCollapsed(element) {
    return element.getAttribute('aria-expanded') !== 'true';
  }

  static unfold(element, layer) {
    layer.setAttribute('aria-hidden', 'false');
    element.setAttribute('aria-expanded', 'true');
    element.setAttribute('disabled', '');
    element.style.visibility = 'hidden';
  }

  static collapse(element, layer) {
    layer.setAttribute('aria-hidden', 'true');
    element.setAttribute('aria-expanded', 'false');
    element.removeAttribute('disabled');
    element.style.visibility = 'visible';
  }

  toogleLayer() {
    const isCollapsed = this.constructor.isCollapsed(this.elements.toggle);
    if (isCollapsed) {
      this.constructor.unfold(this.elements.toggle, this.elements.layer);
    } else {
      this.constructor.collapse(this.elements.toggle, this.elements.layer);
    }
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      if (
        !event.target.closest('[data-js-element="floating-layer__layer"]') &&
        event.target !== this.elements.toggle
      ) {
        this.constructor.collapse(this.elements.toggle, this.elements.layer);
      }
    });

    this.elements.toggle.addEventListener('click', this.toogleLayer.bind(this));

    inViewport(this.elements.layer, 0.8, (entries) => {
      if (!entries[0].isIntersecting && entries[0].boundingClientRect.top < 0)
        this.constructor.collapse(this.elements.toggle, this.elements.layer);
    });
  }
}
